import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent, IonLabel } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00058CapteurTemperatureEnum } from '../../../Enum/P00058CapteurTemperatureEnum';
import { P00058SeuilTemperatureHorsGel } from '../../../Enum/P00058SeuilTemperatureHorsGel';

@Component({
  selector: 'app-p00058-pompe-mise-en-oeuvre-prevention-gel',
  templateUrl: './p00058-pompe-mise-en-oeuvre-prevention-gel.component.html',
  styleUrls: ['./p00058-pompe-mise-en-oeuvre-prevention-gel.component.scss'],
  imports: [
    AffichageWarningComponent,
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    IonLabel,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    TranslatePipe,
  ],
})
export class P00058PompeMiseEnOeuvrePreventionGelComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  hasProduitP00030() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00030()) ?? 0;
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00058CapteurTemperatureEnum =
    P00058CapteurTemperatureEnum;
  protected readonly P00058SeuilTemperatureHorsGel =
    P00058SeuilTemperatureHorsGel;
}
